import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    frame: String,
    uncheckedValue: String
  }

  connect() {
    this.element.addEventListener('change', this.handleChange)
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleChange)
  }

  handleChange = e => {
    const { checked, name } = e.target
    const url = new URL(window.location.href)
    if (checked) {
      url.searchParams.set(name, 'true')
    } else if (this.hasUncheckedValueValue) {
      url.searchParams.set(name, this.uncheckedValueValue)
    } else {
      url.searchParams.delete(name)
    }
    const options = {}
    if (this.hasFrameValue) {
      // navigate frame only but make sure param is included in state
      window.history.replaceState(history.state, {}, url.toString())
      options.frame = this.frameValue
    }
    Turbo.visit(url.toString(), options)
  }
}
